import config from '../config'
import req from '../util/request'
import state from '../store/state'

export default {
  /**
   * 获取当前表单是否填写过
   * @see https://yapi.geekbang.org/project/170/interface/api/20080
   * @param {Number} id 表单id
   * @returns
   */
  getFormSubmitStatus (id) {
    return req({
      url: `${config.InfoQServer}/activity/v2/form/isSub`,
      data: { id }
    })
  },

  /**
   * 获取广告数据
   * @see https://yapi.geekbang.org/project/119/interface/api/6420
   * @param {Object} data              接口参数
   * @param {String} data.place_id     广告位 ID
   * @param {Number} data.place_type   广告类型 [1:普通广告,2:feed流广告（有楼层）]
   * @param {Object} data.floor        广告楼层信息
   * @param {Number} data.begin        开始楼层，从 1 开始
   * @param {Number} data.end          结束楼层，-1 表示获取全部楼层的全部广告
   * @param {String} data.page_tag     页面关联标签
   */
  getAdvertising (data) {
    return req({
      host: config.adServer,
      url: '/public/serving/v2',
      data
    })
    /**
     * @param {Url}    pc  素材 url, PC 端
     * @param {Url}    mb  素材 url, 移动端
     * @param {Url}    lp  广告主落地页 url
     * @param {Url}    v   广告展示监控 url
     * @param {Url}    c   广告点击监控 url
     * @param {String} d   广告描述
     * @param {Number} mt  素材类型 [1:普通,2:大图文,3:小图文,4:文字, 5: geobanner,6:文章样子的图文,7:横图]
     */
      .then((res = []) => {
        res = Array.isArray(res) ? res : []

        const list = []

        res.forEach(item => {
          const ideas = []
          // 是否显示角标
          const cornerMark = item.corner_mark || 0

          item.ms.forEach(idea => {
            ideas.push({
              cornerMark,
              markLabel: '商业推荐',
              src: state.isMobile ? idea.mb : idea.pc,
              route: idea.lp,
              visible: idea.v,
              click: idea.c,
              desc: idea.d,
              ideaType: idea.mt,
              extra: (idea.ex && JSON.parse(idea.ex)) || {},
              placeId: data.place_id
            })
          })

          list.push({
            label: item.d || '',
            ideas: ideas
          })
        })

        return list
      })
      .catch(() => {
        return Promise.resolve([])
      })
  },

  /**
   * 获取 GeoBanner 广告数据
   * @see https://yapi.geekbang.org/project/119/interface/api/6420
   */
  getGeoBanner () {
    const postData = {
      place_id: 22,
      place_type: 4
    }

    return this.getAdvertising(postData).then(res => {
      if (res[0] && Array.isArray(res[0].ideas)) {
        return res[0].ideas[0]
      }
    })
  }
}
